import GoogleAdSlot from "./GoogleAdSlot";

/**
 * Sticky right-edge vertical ad rail.
 * Only visible on wide screens (>=1280px). Fixed positioning — does not
 * shift the main content layout.
 */
export default function RightAdRail() {
  return (
    <aside
      data-testid="right-ad-rail"
      aria-label="Sponsored"
      className="hidden xl:block fixed top-24 right-4 z-30 w-40"
    >
      <div className="rounded-2xl bg-white/60 backdrop-blur brutal-shadow-sm border border-[#1F2547]/8 overflow-hidden">
        <div className="text-[9px] font-bold uppercase tracking-[0.2em] text-[#5B6079] px-3 pt-2">
          Sponsored
        </div>
        <div className="px-2 pb-2">
          <GoogleAdSlot
            style={{ display: "block", minHeight: "600px", width: "100%" }}
            format="vertical"
            responsive={true}
            testId="right-rail-ad"
          />
        </div>
      </div>
    </aside>
  );
}
